import { DataSourceList } from '@unistocks/features/admin/components/data-source-management/data-source-list';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function DataSourcesScreen() {
  return (
    <>
      <Head>
        <title>{t('::DataSources')}</title>
      </Head>
      <DataSourceList />
    </>
  );
}
